import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router'
import { APP_ROUTES } from '@/common/constants'
import { APP } from '@/common/strings'
import { ONBOARDING_COPY } from '@/locales/en'
import { AccountTypeForm } from './features/account-type/components/AccountTypeForm'
import { useAccountTypeLogic } from './features/account-type/useAccountTypeLogic'
import { useAccountTypeSubmission } from './features/account-type/useAccountTypeSubmission'
import { useFeatureFlags } from '@/common/featureFlags/featureFlags'
import { AccountType } from '@/common/types'
import { useOnboardingProgress } from './useOnboardingProgress'

/** Production page — wires useAccountTypeLogic result to AccountTypeForm.
 *  Navigation logic is handled by useAccountTypeSubmission hook.
 */
export function AccountTypePage() {
    const navigate = useNavigate()
    const { progress } = useOnboardingProgress()
    const logic = useAccountTypeLogic()
    const { showCompanyAccounts } = useFeatureFlags()

    // Handle submission side effects (setPrimaryAccount vs setAccounts, navigation, analytics)
    useAccountTypeSubmission({
        selectedAccountType: logic.data?.accountType ?? null,
        createAccountSuccess: logic.isSuccess,
        createAccountData: logic.createdAccount,
        existingAccount: logic.existingAccount,
        conflictAccountId: logic.conflictAccountId,
    })

    const onBack = () => {
        navigate(APP_ROUTES.SURVEY)
    }

    const supportedAccountTypes = [
        AccountType.INDIVIDUAL,
        AccountType.INDIVIDUAL_TRUST,
        AccountType.COMPANY_TRUST,
        ...(showCompanyAccounts ? [AccountType.COMPANY] : []),
    ]

    return (
        <>
            <Helmet>
                <title>
                    {ONBOARDING_COPY.accountType.pageTitle} | {APP.title}
                </title>
            </Helmet>
            <AccountTypeForm
                progress={progress}
                defaultValues={logic.data}
                loading={logic.loading}
                saving={logic.saving}
                onSubmit={logic.onSubmit}
                onBack={onBack}
                supportedAccountTypes={supportedAccountTypes}
            />
        </>
    )
}
